import { Model } from "bp-common-models-lib";

export class TaxWithheld extends Model {
	public amount_fiat: string;
	public fiat_id: number;
	public fiat_amount_after_tax: string;
}
